// extracted by mini-css-extract-plugin
export default {"reveal":"styles_reveal__PzB7k","visible":"styles_visible__lnneq"};